var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Group } from '../shapes/Group';
import { syncActiveCanvasUiTheme, runWithCanvasUiTheme } from './resolveCanvasTheme';
import { resolveEffectiveUiTokens } from './nodeTheme';
import { installUiRebuild, UI_REBUILD_TYPES } from './uiRebuild';
var registry = {};
export function registerComponent(type, factory) {
    registry[type] = factory;
}
export function createComponentFromJSON(type, props, app) {
    var factory = registry[type];
    if (!factory)
        return null;
    var theme = syncActiveCanvasUiTheme(resolveEffectiveUiTokens(app, props), app);
    return runWithCanvasUiTheme(theme, function () {
        var node = factory(props, app);
        if (node &&
            'children' in node &&
            UI_REBUILD_TYPES.has(type) &&
            !node.metadata.uiRebuild) {
            installUiRebuild(node, app, factory);
        }
        return node;
    });
}
/** Base UI component wrapper */
var UIComponent = /** @class */ (function (_super) {
    __extends(UIComponent, _super);
    function UIComponent(type, options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        _this.type = 'component';
        _this.componentType = type;
        return _this;
    }
    return UIComponent;
}(Group));
export { UIComponent };
export { registry };
